import React from 'react';
import {Row, Col, Card} from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';

import Aux from "../hoc/_Aux";
// import friend from "../App/layout/AdminLayout/NavBar/NavRight/ChatList/Friends/friends";
import Friend from "../App/layout/AdminLayout/NavBar/NavRight/ChatList/Friends/Friend";
import chatMsg from "../App/layout/AdminLayout/NavBar/NavRight/ChatList/Friends/Chat/chat";
import Message from "../App/layout/AdminLayout/NavBar/NavRight/ChatList/Friends/Chat/Messages";

const friend = [
    {
        id: 1,
        photo: 'avatar-2.jpg',
        name: 'Subodh',
        new: 3,
        status: 1,
        time: 'Maharashtra'
    },
    {
        id: 2,
        photo: 'avatar-2.jpg',
        name: 'Mukesh',
        new: 1,
        status: 1,
        time: 'UP'
    },
    {
        id: 3,
        photo: 'avatar-4.jpg',
        name: 'Kumar',
        status: 1,
        time: 'online'
    },
    {
        id: 4,
        photo: 'avatar-1.jpg',
        name: 'Rahul',
        status: 0,
        new: 1,
        time: '10 min ago'
    },
    {
        id: 5,
        photo: 'avatar-4.jpg',
        name: 'Manish',
        status: 0,
        time: '15 min ago'
    },
   
];

class Messages extends React.Component {
    state = {
        chatOpen: true,
        user: {
            id: 6,
        }
    };

    render() {

        const friendList = (friend).map(f => {
            return <Friend key={f.id} data={f} activeId={this.state.user.id} clicked={() => this.setState({chatOpen: true, user: f})} />;
        });

        let message = <div className="text-center text-danger">Chat Not Found</div>;
        chatMsg.filter(chats => {
            if (chats.friend_id === this.state.user.id) {
                message = (chats.messages).map((msg, index) => {
                    return <Message key={index} message={msg} name={this.state.user.name} photo={chats.friend_photo} />;
                });
            }
            return false;
        });

        return (
            <Aux>
                <Row>
                    <Col>
                        <Card className="msg-card" style={{marginBottom:0}}>
                            <Card.Body>
                                <Row>
                                    <Col xl={3} md={12} className='pr-0'>
                                        {/* <div className="h-list-header m-b-5">
                                            <div className="input-group">
                                                <input type="text" id="msg-friends" className="form-control" placeholder="Search Friend . . ." />
                                                <div className="input-group-append">
                                                    <span className="input-group-text"><i className="feather icon-search"/></span>
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="h-list-body">
                                            <div className="msg-user-list scroll-div" style={{height:400}}>
                                                <div className="main-friend-list" style={{height: 400}}>
                                                    <PerfectScrollbar>
                                                        {friendList}
                                                    </PerfectScrollbar>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xl={9} md={12} className='pl-0'>
                                        <div className="h-list-body">
                                            <div className="msg-user-chat scroll-div" style={{height: 360, padding:0}}>
                                                <PerfectScrollbar>
                                                    <div className="main-friend-chat">
                                                        {message}
                                                    </div>
                                                </PerfectScrollbar>
                                            </div>
                                        </div>
                                        <hr/>
                                        <div className="msg-form">
                                            <div className="input-group mb-0">
                                                <input type="text" className="form-control msg-send-chat" placeholder="Text . . ." />
                                                <div className="input-group-append">
                                                    <input type="file" id="imgupload" style={{display:'none'}} />
                                                    <button id="OpenImgUpload" for='imgupload' className="btn btn-secondary btn-icon" type="button" data-toggle="tooltip" title="file attachment"><i className="feather icon-paperclip"/></button>
                                                </div>
                                                <div className="input-group-append">
                                                    <button className="btn btn-theme btn-icon btn-msg-send" type="button"><i className="feather icon-play"/></button>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Aux>
        );
    }
}

export default Messages;